import { useNavigate } from "react-router-dom";
import { ProfileManager } from "./ProfileManager";
import info from "../info.json"

export function Header() {
  let navigate = useNavigate();
  return <div className="flex flex-col py-2 mb-4">
    <div className="flex flex-row justify-between w-full">
      <div className="w-[8rem] ~aspect-logo">
        <img className="cursor-pointer" src="/img/bank-logo.png" /*onClick={() => navigate("/home")} */ />
      </div>
      <div className="~text-[1.5rem] text-[2rem] text-toda-gray font-bold ml-3 flex flex-col justify-center">
        Certified Document Validator
      </div>
      <div></div> {/* placeholder to get page title to align */}
      {/* <ProfileManager /> */}
    </div>
  </div>;
}

export function Footer() {
  return <div className="text-[0.75rem] flex items-center justify-between  w-full text-toda-gray  ~text-gray-800">
    <div>Powered by TODAQ 🇨🇦 2025</div>
    <div className="text-center">CORPORATE CONFIDENTIAL</div>
    <div> Build: {info.build} {info.env && `@${info.env}`} </div>
  </div>
}

export function PageTitle({children}) {
  return <div className="my-4 font-semibold underline uppercase">
    {children}
  </div>
}

export function Page({children}) {
  return <div className="h-full flex flex-col">
    <Header />
    <div className="grow">
      {children}
    </div>
    <Footer/>
  </div>
}
